module.exports = __webpack_public_path__ + "media/3.9d6c432c.wav";